<template>
    <div id="infoList">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form class="rightTop" inline :label-width="80">
            		<h4>信息列表</h4>
                    <Button class="addBtn" @click="addInfo" type="primary" style="margin-top: 0;margin-left: 20px;">新增信息</Button>
                    <Form-item label="信息标题" prop="qy_title">
                        <Input v-model="qy_title"  :maxlength="16" placeholder="请输入信息标题"></Input>
                    </Form-item>
                    <Form-item label="信息类型" prop="qy_type">
                    	<Select style="width: 160px;" clearable v-model="qy_type">
                            <Option v-for="item in typeArr" :key="item.type" :value="item.type">{{item.name}}</Option>
                        </Select>
                        <!--<Input @on-change="changQuery" v-model="qy_type" :maxlength="16" placeholder="请输入信息类型"></Input>-->
                    </Form-item>
                    <!-- <Form-item label="用户角色" prop="qy_rolename">
                        <Select v-model="qy_rolename" clearable style="width:162px">
                            <Option v-for="item in rolenameList" :value="item.rolename" :key="item.rolename">{{ item.rolename }}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="用户部门" prop="qy_department">
                        <Select v-model="qy_department" clearable style="width:162px;">
                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                        </Select>
                    </Form-item> -->

                    <Button type="primary"  @click="submitSearch(actionPage)">搜索</Button>
                </Form>
            </div>
						<div class="center">
                <Table :data="UserData" :columns="theadArr" stripe></Table>
                <Page class="pull-right" :total="totalSize" :current="page" size="small" show-total @on-change="changePage"></Page>
            </div>
            <Row>
              <Modal
                  v-model="modal1"
                  title="下载" ok-text="关闭" cancel-text="">
                  <div style="font-size: 14px;height: 50px;position: relative;z-index: 99;" v-for="item in pictureArr">{{item.name}}<Button style="float: right;" type="primary" @click="downIt(item.name,item.url)">下载</Button></div>
                  <div style="font-size: 14px;height: 50px;position: relative;z-index: 99;" v-for="item in videoArr">{{item.name}}<Button style="float: right;" type="primary" @click="downIt(item.name,item.url)">下载</Button></div>
              	  <div class="downloading" v-show="isDownload">
              	  		<img class="downImg" src="../../assets/infoMana/downLoad.jpg"/><span v-show="videoArr.length">下载视频可能过大，请稍等几分钟</span>
              	  </div>
              </Modal>
            </Row>
            <Row>
              <Modal
                  v-model="modal2"
                  title="活动参加名单" ok-text="关闭" cancel-text="">
                  <span style="font-size: 16px;display: inline-block;height: 30px;line-height: 30px;padding: 0 20px;" v-for="(item,index) in peopleList" :key="item+index">{{index+1}}、{{item.realname}}</span>
                  <span v-show="getArrLength(peopleList)">暂无参加人员</span>
              </Modal>
            </Row>
        </i-col>
    </div>
</template>


<script>
import "assets/../global/setting";
export default {
  data() {
    return {
      isDownload:false,
      modal2:false,
      qy_title: "",
      qy_type: "",
      totalSize: 10,
      pageSize: 10,
      page: 1,
      rolenameList: [],
      UserData: [],
      actionPage: 1,
      modal1: false,
      pictureArr:[],
      peopleList: [],
      videoArr:[],
      typeArr:[
      	{
      		type:"activity",
      		name:"活动报名"
      	},
      	{
      		type:"simple",
      		name:"普通信息"
      	}
      ],
      theadArr: [
        {
          title: "信息标题",
          key: "title"
        },
        {
          title: "信息类型",
          key: "type"
        },
        {
          title: "活动报名截止时间",
          key: "deadline"
        },
        {
          title: "发布状态",
          key: "status"
        },
        {
          title: "用户操作",
          align: "center",
          width: 300,
          render: (h, params) => {
            
            if(params.row.status === "已发布" && params.row.type == "活动报名"){
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.download(params.row);
                      }
                    }
                  },
                  "下载"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.getPeopleList(params.row);
                      }
                    }
                  },
                  "名单"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.delUser(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }else if(params.row.status === "已发布"){
            	return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.download(params.row);
                      }
                    }
                  },
                  "下载"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.edit(params.row, params.index);
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.delUser(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }else{
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.download(params.row);
                      }
                    }
                  },
                  "下载"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.edit(params.row, params.index);
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.send(params.row, params.index);
                      }
                    }
                  },
                  "发布"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.delUser(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
            
          }
        }
      ]
    };
  },
  methods: {
  	getArrLength(arr){
  		if(arr.length>0){
  			return false;
  		}else{
  			return true;
  		}
  	},
  	getPeopleList(row){
		this.modal2 = true;
		let that = this;
        let params = {};
        params.data = {
          order: { _id: -1 },
          searchValue: {
          	id : row.id, is_join:true,
          }
        };
        params.url = "/sys/receiveuser/list";
        params.token = window.localStorage.getItem("token");
        params.success = function(res) {
            console.log(res);
            that.peopleList = res.data.result.result;
        };
        this.ajaxPost(params);
  	},
  	changQuery(){
		this.submitSearch(this.actionPage)
	},
    submitSearch: function(page) {
      page = page == "" || page == undefined ? this.page : page;
      let that = this;
      let params = {};
      if(this.qy_type==undefined){
          this.qy_type=''
      }
      params.data = {
        page: page,
        pageSize: this.pageSize,
        order: { _id: -1 },
        searchValue: {
          title: this.qy_title + "|#|like",
          content: "" + "|#|like",
          type: this.qy_type + "|#|like"
        }
      };
      console.log("qy_type",this.qy_type);
      params.url = "/manage/messagelist/list";
      params.token = window.localStorage.getItem("token");
       params.success = function(res) {
        console.log(res.data.result);
        res = res.data;
        for(var i=0;i<res.result.result.length;i++) {
          if(res.result.result[i].type == "activity"){
            res.result.result[i].type = "活动报名"
          }else if(res.result.result[i].type == "simple"){
            res.result.result[i].type = "普通信息"
          }
          if(res.result.result[i].status){
            res.result.result[i].status = "已发布"
          }else{
            res.result.result[i].status = "未发布";
          }
        }
        that.UserData = res.result.result;
        that.totalSize = res.result.totalSize;
        that.page = res.result.page;
      };
      this.ajaxPost(params);
    },
    changePage: function(page) {
      this.submitSearch(page);
      this.actionPage = page;
    },
    edit(row){
      this.$router.push("/data/editInfo/"+row.id);
    },
    addUser: function() {
      this.formItem = {
        username: "",
        password: "",
        realname: "",
        email: "",
        mobile: "",
        roles: [],
        departmentName: "",
        identification: "",
        finger: "",
        work_date: "",
        entry_date: ""
      };
      this.updateTitle = "新增用户";
      this.btnChange = false;
      this.btnSave = true;
      this.modal1 = true;
      this.changeRead = false;
      this.uploadList = [];
      this.path = "";
      this.url = "";
      this.isPassWord = true;
      this.picture = true;
    },
    send(row) {
      let that = this;
      let params = {};
      params.data = row;
      if(params.data.type == "活动报名"){
        params.data.type = "activity"
      }else if(params.data.type == "普通信息"){
        params.data.type = "simple"
      }
      if(params.data.status == "未发布"){
        params.data.status = false;
      }else if(params.data.status == "已发布"){
        params.data.status = true;
      }
      params.url = "/manage/messagelist/release";
      params.token = window.localStorage.getItem("token");
      params.success=function(res){
      	if(params.data.type == "activity"){
	        params.data.type = "活动报名"
	      }else if(params.data.type == "simple"){
	        params.data.type = "普通信息"
	      }
	      if(params.data.status == false){
	        params.data.status = "未发布";
	      }else if(params.data.status == true){
	        params.data.status = "已发布";
	      }
          res = res.data;
          that.$Message.success(res.message);
          that.submitSearch(parseInt(that.actionPage));
      }
      that.ajaxPost(params);     
    },
    download(row) {
      this.modal1 = true;
      this.pictureArr = row.image;
      this.videoArr = row.video;
    },
    downIt(fileName,url){
      let that = this;
      let params = {};
      this.isDownload = true;
      url = url.split(parameters.domain).join("");
      params.data = {
        "path" : url
      };
      
      params.url = "/manage/messagelist/download";
      params.token = window.localStorage.getItem("token");
      params.success=function(res){
      	console.log(res);
        var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    　　var downloadElement = document.createElement('a');
    　　var href = window.URL.createObjectURL(blob); //创建下载的链接
    　　downloadElement.href = href;
    　　downloadElement.download = fileName; //下载后文件名
    　　document.body.appendChild(downloadElement);
    　　downloadElement.click(); //点击下载
    　　document.body.removeChild(downloadElement); //下载完成移除元素
    　　window.URL.revokeObjectURL(href); //释放掉blob对象 
    	that.isDownload = false;
      }
      that.ajaxGet(params); 
    },
    delUser(row) {
      let that = this;
        this.$Modal.confirm(
            {
              content:'确认删除该信息？',
              onOk:function () {
                  let params = {};
                  params.data = {
                    '_id':row._id,
                    'id':row.id
                  };
                  params.url = "/manage/messagelist/delete";
                  params.token = window.localStorage.getItem("token");
                  params.success=function(res){
                      res = res.data;
                      that.$Message.success(res.message);
                      that.submitSearch(parseInt(that.actionPage));
                }
                that.ajaxPost(params);
              }
            }
        )
    },
    addInfo() {
      this.$router.push("/data/addInfo")
    }
  },
  mounted: function() {
    console.log(this.$router)
    this.submitSearch(this.page);
  }
};
</script>
<style scoped="scoped">
	.downloading{
		line-height: 31px;
	}
	.downImg{
	  	width: 31px;
	  	height: 31px;
	  	margin-right: 10px;
	  	object-fit: cover;
	  	animation: circle 4s linear infinite;
	  }
	@keyframes circle{
	  	from{transform: rotate(0);}
	  	to{transform: rotate(360deg);}
	  }
</style>
<style lang="less">
#infoList {
  .addBtn {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .ml32 {
    height: 36px;
    line-height: 36px;
  }
  .query-bar{
    		background: transparent;
    		height: 80px;
    		padding-top: 20px;
    		margin-bottom: 30px;
    		border-bottom: 1px solid #e9eaec;
    	}
    	table{
    		text-align: center;
    		th{
    			height: 50px;
    			font-size: 16px;
    		}
    		th,td{
    			text-align: center;
    		}
    	}
    	.ivu-page{
	    	margin-top: 30px;
	    }
    	.rightTop{
    		h4{
    			font-size: 18px;
    			color: #45AAF9;
    			float: left;
    			text-align: left;
    		}
    		text-align: left;
    		.ivu-form-item{
    			text-align: left;
    		}
    	}
	.ivu-form-item {
	  margin-bottom: 0px;
	}
}
.width90 {
  width: 90% !important;
}
.user_msg {
  .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/infoMana/infoList.vue